import React, { useState, useEffect } from "react";
import { Table, Image, Col, Row } from "react-bootstrap";
import BasicPagination from "../../../Pagination/Pagination";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import {
  get_organization_details_by_id,
  get_settlement_amount,
  get_donations_user_details,
  get_donations_user_details_referal,
} from "../../../../store/actions/SuperAdminActions/superAdminManageTransactions";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
const SuperAdminDonationDetails = (props) => {
  const { OrganizationId, SettleMentId, DonationType } = useParams();
  //state
  const [page, setPage] = useState(1);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    setPage(pageNo);
  };
  const [orgDetails, setOrgDetails] = useState({});
  const onSuccessGetOrgName = (data) => {
    setOrgDetails(data);
  };
  const [settlementDetails, setSettlementDetails] = useState({});
  const onSuccessGetSettlementDetails = (data) => {
    setSettlementDetails(data);
  };

  const [donarDetails, setDonarDetails] = useState([]);

  const onSuccess = (data) => {
    setDonarDetails(data);
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_organization_details_by_id(
      token,
      OrganizationId,
      onSuccessGetOrgName
    );
    props.get_settlement_amount(
      token,
      SettleMentId,
      onSuccessGetSettlementDetails
    );

    if (DonationType === "1") {
      props.get_donations_user_details(
        token,
        OrganizationId,
        SettleMentId,
        onSuccess
      );
    } else {
      props.get_donations_user_details_referal(
        token,
        OrganizationId,
        SettleMentId,
        onSuccess
      );
    }
  }, []);

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          {console.log(donarDetails)}
          <div className="container-fluid">
            <div className="row">
              <div className="left-side-panel">
                <LeftSideNavigation displayLink={1} />
              </div>
              <div className="super-admin-right-side-panel">
                <HomeReusableTopBarNavigation />
                <div className="super-admin-inside-right-side-panel">
                  <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                    <div className="f24_700_HelveticaNeue">
                      Donation Details
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="enIMG75">
                      <Image
                        src={require("../../../../assets/images/UserManagement/fhr7.png")}
                        alt="View"
                        title="View"
                        fluid
                        className="w-100 h-100"
                      />
                    </div>
                    <div className="pl-3 row">
                      <Col
                        lg={10}
                        xl={8}
                        className="d-flex flex-column justify-content-between"
                      >
                        <div className="f24-500">
                          {orgDetails.organization_name}
                        </div>
                        <div className="f14-400 text-dark">
                          {orgDetails.organization_address}
                        </div>
                      </Col>
                    </div>
                  </div>
                  <hr />
                  <Row>
                    <Col md={7}>
                      <Row>
                        <Col md={6}>
                          <div className="f12-700 mb-3">Period</div>
                          <div className="f12-400">
                            {moment(settlementDetails.createdAt).format(
                              "DD MMM, YYYY"
                            )}
                            <br />
                            {moment(settlementDetails.createdAt).format("LT")}
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="f12-700 mb-3">
                            Total Donation Amount Paid
                          </div>
                          <div className="f12-400">
                            ₹ {settlementDetails.donation_amount}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={5}>
                      <div className="d-flex justify-content-end align-items-center">
                        <div className="enSuccessLBL mr-3">
                          {settlementDetails.payment_status}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <hr />
                  <div className="f16_700_HelveticaNeue">Donation Via</div>
                  <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                    <Table className="HideShowTable enMinWidth900">
                      {DonationType === "2" ? (
                        <thead>
                          <tr className="super_admin_all_users_table_head">
                            <th style={{ width: "10%" }} className="f12-700">
                              Referral ID
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Date
                            </th>

                            <th style={{ width: "15%" }} className="f12-700">
                              Referee Name
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Referee Role
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Referred User ID
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Referred User Name
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Donation Amount
                            </th>
                          </tr>
                        </thead>
                      ) : (
                        <thead>
                          <tr className="super_admin_all_users_table_head">
                            <th style={{ width: "10%" }} className="f12-700">
                              Transaction ID
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Date
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              User ID
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              User
                            </th>
                            <th style={{ width: "10%" }} className="f12-700">
                              Request Type
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Payment To
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Payment Method
                            </th>
                            <th style={{ width: "15%" }} className="f12-700">
                              Donation Amount
                            </th>
                          </tr>
                        </thead>
                      )}

                      {DonationType === "2" ? (
                        <tbody>
                          {donarDetails &&
                            donarDetails.map((donation, index) => (
                              <tr
                                className="super_admin_all_users_table_body"
                                key={index}
                              >
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400 text-break">
                                    {donation &&
                                      donation.referee_id &&
                                      donation.referee_id._id}
                                  </div>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400">
                                    {" "}
                                    {moment(donation.createdAt).format(
                                      "DD MMM, YYYY"
                                    )}
                                  </div>
                                </td>

                                <td style={{ width: "15%" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="enIMG33 rounded-circle mr-3">
                                      <Image
                                        fluid
                                        src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
                                        alt="Icon"
                                      />
                                    </div>
                                    <div className="f12-400">
                                      {donation &&
                                        donation.referee_id &&
                                        donation.referee_id.first_name}{" "}
                                      {donation &&
                                        donation.referee_id &&
                                        donation.referee_id.last_name}
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <div className="f12-400">
                                    {donation && donation.referee_id_Role}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="d-flex align-items-center">
                                    <div className="f12-400 text-break">
                                      {donation &&
                                        donation.referred_id &&
                                        donation.referred_id._id}
                                    </div>
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="f12-400">
                                    {donation &&
                                      donation.referred_id &&
                                      donation.referred_id.first_name}{" "}
                                    {donation &&
                                      donation.referred_id &&
                                      donation.referred_id.last_name}
                                  </div>
                                </td>
                                <td style={{ width: "15%" }}>
                                  <div className="f12-400">
                                    ₹ {donation && donation.amount_disbursement}
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      ) : (
                        <tbody>
                          {donarDetails.map((name, index) => (
                            <tr
                              className="super_admin_all_users_table_body"
                              key={index}
                            >
                              <td style={{ width: "10%" }}>
                                <div className="f12-400 text-break">
                                  {name.donation_settlement_id}
                                </div>
                              </td>
                              <td style={{ width: "10%" }}>
                                <div className="f12-400">
                                  {" "}
                                  {moment(name.createdAt).format(
                                    "DD MMM, YYYY"
                                  )}
                                </div>
                              </td>
                              <td style={{ width: "10%" }}>
                                <div className="f12-400 text-break">
                                  {name && name.user_id && name.user_id._id}
                                </div>
                              </td>
                              <td style={{ width: "15%" }}>
                                <div className="d-flex align-items-center">
                                  <div className="enIMG33 rounded-circle mr-3">
                                    <Image
                                      fluid
                                      src={require("../../../../assets/images/ActionImages/demoprofile.jpg")}
                                      alt="Icon"
                                    />
                                  </div>
                                  <div className="f12-400 text-break">
                                    {name &&
                                      name.user_id &&
                                      name.user_id.first_name}{" "}
                                    {name &&
                                      name.user_id &&
                                      name.user_id.last_name}
                                  </div>
                                </div>
                              </td>
                              <td style={{ width: "10%" }}>
                                <div className="f12-400">
                                  {" "}
                                  {name &&
                                  name.order_id &&
                                  name.order_id.order_type === 0
                                    ? "takeaway"
                                    : name &&
                                      name.order_id &&
                                      name.order_id.order_type === 1
                                    ? "curb side"
                                    : props.orderDetails &&
                                      name &&
                                      name.order_id &&
                                      name.order_id.order_type === 3
                                    ? "dine in"
                                    : ""}
                                </div>
                              </td>
                              <td style={{ width: "15%" }}>
                                <div className="d-flex align-items-center">
                                  <div className="enIMG33 rounded-circle mr-3">
                                    <Image
                                      fluid
                                      //src={require("../../../../assets/images/superadmin/macd.png")}
                                      src={
                                        name &&
                                        name.restaurant_id &&
                                        name.restaurant_id.logo_url
                                      }
                                      alt="Icon"
                                    />
                                  </div>
                                  <div className="f12-400">
                                    {" "}
                                    {name &&
                                      name.restaurant_id &&
                                      name.restaurant_id.restaurant_name}
                                  </div>
                                </div>
                              </td>
                              <td style={{ width: "15%" }}>
                                <div className="f12-400">
                                  {" "}
                                  {name &&
                                  name.transactional_id &&
                                  name.transactional_id.transaction_type ===
                                    "SCAN_AND_PAY"
                                    ? "Scan & Pay"
                                    : "Razor Pay"}
                                </div>
                              </td>
                              <td style={{ width: "15%" }}>
                                <div className="f12-400">
                                  ₹{" "}
                                  {name &&
                                    name.donation_amount &&
                                    name.donation_amount.amount}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </Table>
                  </div>
                  <BasicPagination
                    totalRecords={donarDetails.length}
                    limit={10}
                    batch={page}
                    onBatchChange={(e) => handleBatchChange(e)}
                  />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
SuperAdminDonationDetails.propTypes = {
  auth: PropTypes.object.isRequired,
  get_organization_details_by_id: PropTypes.func.isRequired,
  get_settlement_amount: PropTypes.func.isRequired,
  get_donations_user_details_referal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  all_donations: state.superadminManageTransactions.all_donations,
});

export default connect(mapStateToProps, {
  get_organization_details_by_id,
  get_settlement_amount,
  get_donations_user_details,
  get_donations_user_details_referal,
})(SuperAdminDonationDetails);
